import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../apiAccess/PromiseStateContainer';
import BASE_URL from '../apiAccess/urls';
import { addIndentToNip, createSubheaderRow, createRowData, createClaimableNipRows } from '../util/util';
import ComponentsTable from './ComponentsTable';

const createClaimableRows = (fullComponentSet, full, units, claimTexts, nipComponents) => {
  return Object.keys(claimTexts.claimables).map(code => {
    const claimText = claimTexts.claimables[code];
    if (!claimText) { return null; }
    // don't show what's already in nip
    if (nipComponents.find(nip => nip.code === code)) { return null; }

    const component = fullComponentSet.components.find(component => component.code === code);
    const commponentOfTheFood = full.find(commponentOfTheFood => commponentOfTheFood.component_code === code);
    return createRowData({component, units, commponentOfTheFood, claimText});
  }).filter(n => n);
};

class ClaimableTable extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    this.props.setCsvHeader([
      {label: 'Category', key: 'category'},
      {label: 'Nutrient', key: 'nutrient'},
      {label: 'Unit', key: 'unit'},
      {label: 'Quantity per Serve', key: 'qps'},
      {label: '%DI per Serve', key: 'rdi'},
      {label: 'Quantity per 100 g', key: 'qpg'},
      {label: 'Potential Claim', key: 'claim'},
    ]);
  }

  render() {
    const {
      unitFetch,
      nipComponentSetFetch, nipFetch,
      fullComponentSetFetch, fullFetch,
      claimTextFetch
    } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([
          unitFetch,
          nipComponentSetFetch, nipFetch,
          fullComponentSetFetch, fullFetch,
          claimTextFetch
        ])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([
    units,
    nipComponentSet, nip,
    fullComponentSet, full,
    claimTexts
  ]) {
    const nipComponents = addIndentToNip(nipComponentSet);

    const tableData = claimTexts && claimTexts.claimables
      ? createSubheaderRow('NIP')
        .concat(createClaimableNipRows(nipComponents, nip, units, claimTexts))
        .concat(createSubheaderRow('OTHER POTENTIAL CLAIMABLE'))
        .concat(createClaimableRows(fullComponentSet, full, units, claimTexts, nipComponents))
      : []; // if claimTexts for the food does not exist, pass empty data to table

    return (
        <ComponentsTable
        tableType='claimable'
        tableData={tableData}
        setCsvData={this.props.setCsvData}
      />
    );
  }
}

ClaimableTable.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  nipComponentSetFetch: PropTypes.instanceOf(PromiseState),
  nipFetch: PropTypes.instanceOf(PromiseState),
  fullComponentSetFetch: PropTypes.instanceOf(PromiseState),
  fullFetch: PropTypes.instanceOf(PromiseState),
  claimTextFetch: PropTypes.instanceOf(PromiseState),
  recordid: PropTypes.string.isRequired,
  servingSize: PropTypes.number,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

export default connect(props => {
  let query = typeof props.servingSize === 'number' ? `?amount=${props.servingSize}&` : '?';
  let claimablesQuery = typeof props.servingSize === 'number' ? `?serving_size=${props.servingSize}` : '';
  return {
    unitFetch: `${BASE_URL}/unit`,
    nipComponentSetFetch: `${BASE_URL}/component/set/1`,
    nipFetch: `${BASE_URL}/fiav/food/${props.recordid}${query}comp_group_id=1`,
    fullComponentSetFetch: `${BASE_URL}/component/set/12`,
    fullFetch: `${BASE_URL}/fiav/food/${props.recordid}${query}comp_group_id=12`,
    claimTextFetch: `${BASE_URL}/food/${props.recordid}/claimables${claimablesQuery}`,
  };
})(ClaimableTable);



// WEBPACK FOOTER //
// ./src/components/foodDetail/Claimable.js